import { useState, useEffect, useRef } from "react";
import io from "socket.io-client";

function useBotLogs(botId) {
	const [logs, setLogs] = useState([]);
	const [connected, setConnected] = useState(false);
	const socketRef = useRef(null);

	useEffect(() => {
		if (!botId) return;

		// Create socket connection
		const socketUrl = process.env.NODE_ENV === "production" ? window.location.origin : "http://localhost:5000";

		const socket = io(socketUrl);
		socketRef.current = socket;

		// Connection established
		socket.on("connect", () => {
			setConnected(true);
			socket.emit("subscribe-to-logs", botId);
		});

		// Connection lost
		socket.on("disconnect", () => {
			setConnected(false);
		});

		// Receive initial logs
		socket.on("initial-logs", (data) => {
			setLogs(data.logs || []);
		});

		// Receive individual log messages
		socket.on("log", (log) => {
			setLogs((prevLogs) => [...prevLogs, log].slice(-500));
		});

		// Clean up on unmount
		return () => {
			if (socket) {
				socket.emit("unsubscribe-from-logs", botId);
				socket.disconnect();
			}
		};
	}, [botId]);

	// Clear logs
	const clearLogs = () => {
		setLogs([]);
	};

	return {
		logs,
		connected,
		clearLogs,
	};
}

export default useBotLogs;
